import { useEffect, useRef } from 'react';
import { Box, useTheme } from '@mui/material';
import CustomLink from '@/components/shared/custom/custom-link';

const TWTTR_SCRIPT_ID = 'twitter-wjs';

const TweetEmbed = ({ tweetId, theme: themeProp }) => {
    const ref = useRef();
    const muiTheme = useTheme();

    // ✅ Limpiar tweetId: extraer solo el ID numérico sin parámetros de query
    const cleanTweetId = tweetId?.split('?')[0]?.trim() || tweetId;

    // Determinar el tema: prop > MUI > 'light'
    const theme = themeProp || (muiTheme.palette.mode === 'dark' ? 'dark' : 'light');

    useEffect(() => {
        // Verificar si el script ya está en el DOM
        const scriptExists = document.getElementById(TWTTR_SCRIPT_ID);

        if (!window.twttr && !scriptExists) {
            const script = document.createElement('script');
            script.id = TWTTR_SCRIPT_ID;
            script.src = 'https://platform.twitter.com/widgets.js';
            script.async = true;
            document.body.appendChild(script);
        } else if (window.twttr && window.twttr.widgets) {
            window.twttr.widgets.load();
        }
    }, [cleanTweetId, theme]);

    // Colores de fondo según el tema
    const backgroundColor = theme === 'dark' ? '#15202b' : '#fff';

    return (
        <Box
            sx={{
                background: backgroundColor,
                borderRadius: 2,
                p: 1,
                m: 0,
                width: '100%',
                maxWidth: 550,
            }}
        >
            <blockquote
                ref={ref}
                className="twitter-tweet"
                data-theme={theme}
                style={{
                    margin: 0,
                }}
            >
                <CustomLink href={`https://twitter.com/x/status/${cleanTweetId}`}></CustomLink>
            </blockquote>
        </Box>
    );
};

export default TweetEmbed;
